const doc = [({"ja":({"adminButtonHotelCheckIn":({"addGuest":"ゲストを追加", "addRoom":"客室を追加", "deleteGuest":"ゲストを削除", "deleteRoom":"客室を削除", "setUpMembership":"会員設定する"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;